// Print / PDF on an agreement: choose which of its documents go on paper instead
// of always the whole merged copy (owner, 2026-10-06). The server's HTML names each
// document's .page — data-doc ("agreement" | "inventory" | "lou"), data-doc-title
// and data-doc-ref (see the OTP / OTR templates). The owner's Letter of Undertaking
// starts unticked: it states CID's fee to the vendor / landlord, and the copy most
// often printed is the one handed to the purchaser / tenant.
//
// The same file in cid-agent-pwa/src/lib/printDocs.js and
// cid_admin_portal/src/utils/printDocs.js — keep the two identical.

/** The documents a rendered copy holds, in page order. Fewer than two: no choice to make. */
export function docsInHtml(html) {
  if (!html || typeof DOMParser === 'undefined') return [];
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return Array.from(doc.querySelectorAll('.page[data-doc]')).map((el) => ({
    key: el.getAttribute('data-doc'),
    title: el.getAttribute('data-doc-title') || el.getAttribute('data-doc'),
    ref: el.getAttribute('data-doc-ref') || '',
  }));
}

/** What the picker starts with: everything but the LOU. */
export const defaultPicked = (docs) => docs.filter((d) => d.key !== 'lou').map((d) => d.key);

/**
 * CSS that leaves only `picked` on paper. The first one printed loses its forced
 * page break (the attached documents each start a new page), or the paper would
 * open on a blank sheet. `media` 'print' keeps the screen showing the whole copy.
 */
export function printPickCss(docs, picked, media = 'print') {
  const keep = new Set(picked);
  const rules = docs
    .filter((d) => !keep.has(d.key))
    .map((d) => `.page[data-doc="${d.key}"]{display:none !important}`);
  const first = docs.find((d) => keep.has(d.key));
  if (first) rules.push(`.page[data-doc="${first.key}"]{break-before:auto !important;page-break-before:auto !important}`);
  const css = rules.join('\n');
  return media ? `@media ${media}{\n${css}\n}` : css;
}

/** Put printPickCss into a document (an iframe's), replacing any earlier pick. */
export function applyPrintPick(doc, docs, picked) {
  if (!doc) return;
  const old = doc.getElementById('cid-print-pick');
  if (old) old.remove();
  if (!picked) return;
  const style = doc.createElement('style');
  style.id = 'cid-print-pick';
  style.textContent = printPickCss(docs, picked);
  (doc.head || doc.body || doc.documentElement).appendChild(style);
}
